import { Modal }               from 'antd';
import type { ModalFuncProps } from 'antd/es/modal';
import handleApiError          from './handleApiError';

const modalConfirm = (props: ModalFuncProps) => Modal.confirm({
  cancelText: `Annuler`,
  maskClosable: true,
  okText: `Continuer`,
  title: 'Attention !',
  width: 450,

  ...props,

  onOk: async () => {
    try {
      if (props.onOk) {
        await props.onOk();
      }
    } catch (err) {
      handleApiError(err);
    }
  },
});

export const modalConfirmAsync = (props: ModalFuncProps) => {
  return new Promise(resolve => {
    modalConfirm({
      ...props,
      onCancel: async () => {
        if (props.onCancel) {
          await props.onCancel();
        }

        resolve(true);
      },
      onOk: async () => {
        if (props.onOk) {
          await props.onOk();
        }

        resolve(true);
      },
    });
  });
};

export default modalConfirm;
